export default {
    name: "FlowHeader",
    props: {
        isIndependent: {
            type: Boolean,
            required: false
        },
        isStafet: {
            type: Boolean,
            required: false
        }
    },
    setup(props) {
        const closeFlow = function(returnUrl) {
            const referrer = document.referrer
            const currentHost = window.location.host
            const referrerIsInternal = referrer && new URL(referrer).host === currentHost;
            if (referrerIsInternal) {
                history.back();
            } else {
                window.location = returnUrl;
            }
        }

        return {
            closeFlow,
            isIndependent: props.isIndependent,
            isStafet: props.isStafet
        }
    }
}
